export default __webpack_public_path__ + "static/media/ca-2-lqMAX.e9ae19c2.avif";